// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__13cUt","alert":"SettungsInbox_alert__1pFZd"};